import React, { useState, useEffect } from "react";
import Header from "../../components/header/header";
import Pagination from "react-bootstrap/Pagination";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./logsPathfind.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckDouble,
  faFilter,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import Paper from "@mui/material/Paper";
import CustomPagination from "../../components/hooks/pagination";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import { getLogsPathfind } from "../../services/api_logs_pathfind";
import dataHoraFormatada from "../../components/hooks/dataHoraFormatada";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#00C6C1",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const LogsPathfind = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);


  //conexão com o back
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getLogsPathfind();

        // O serviço devolve undefined quando a requisição falha (rede, CORS, timeout).
        if (!response || !Array.isArray(response.data)) {
          throw new Error("Resposta inválida ou ausente do servidor");
        }

        const sortedData = response.data.sort((a,b) => new Date(b.data_hora) - new Date(a.data_hora))

        setDados(sortedData); // Corrigido: Setar dados com response.data.empresas
        //console.log(sortedData, 'informações dos logs da pathfind');
      } catch (error) {
        console.error("Erro ao obter dados:", error);
        setLoadError(
          "Não foi possível carregar os logs. O servidor não respondeu ou demorou demais; tente novamente em instantes."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const filterData = () => {
      if (dados && dados.length > 0) {
        const filtered = dados.filter(
          (item) =>
            //(typeof item.envio && item.envio.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.erro && item.erro.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.status && item.status.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.tipo && item.tipo.toLowerCase().includes(searchTerm.toLowerCase())) ||
            //(typeof item.retorno && item.retorno.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.data_hora && dataHoraFormatada(item.data_hora).toString().includes(searchTerm))||
            (item.id && item.id.toString().includes(searchTerm)) 
            //(item.idRequisicaoSankhya && item.idRequisicaoSankhya.toString().includes(searchTerm))
        );

        setFilteredData(filtered);
        setCurrentPage(1);
      } else {
        // Caso os dados estejam vazios ou undefined, limpar os dados filtrados
        setFilteredData([]);
        setCurrentPage(1);
      }
    };

    filterData();
  }, [searchTerm, dados]);


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchTerm
    ? filteredData
      ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
      : []
    : dados && dados.length > 0
    ? dados.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const totalPages = Math.ceil(
    (searchTerm
      ? filteredData
        ? filteredData.length
        : 0
      : dados
      ? dados.length
      : 0) / itemsPerPage
  );

  //paginação
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  

    function ExpansibleRow(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(false);
    
        return (
          <React.Fragment>
            <TableRow
              className="table-row"
              sx={{ "& > *": { borderBottom: "unset" } }}>
              <TableCell />
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell component="th" scope="row">
                {dataHoraFormatada(row.data_hora)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.erro || "Sem erros"}
              </TableCell>
              {/*<TableCell component="th" scope="row">
                {row.idRequisicaoSankhya}
              </TableCell>*/}
              <TableCell component="th" scope="row">
                {row.status}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.tipo}
              </TableCell>
              <TableCell style={{justifyContent: 'flex-end', borderBottom:"none"}} align="left" className="d-flex">
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                  <p>
                    <strong>ID:</strong> {row.id}
                  </p>
                  <p>
                    <strong>Data e Hora:</strong> {dataHoraFormatada(row.data_hora)}
                  </p>
                  <p>
                    <strong>Envio:</strong> {row.envio}
                  </p>
                  <p>
                    <strong>Erro:</strong> {row.erro || 'Sem Erros'}
                  </p>
                  <p>
                    <strong>ID Requisição Sankhya:</strong> {row.idRequisicaoSankhya || 'ID não encontrado'}
                  </p>
                  <p>
                    <strong>Retorno:</strong> {row.retorno || 'Retorno não encontrado'}
                  </p>
                  <p>
                    <strong>Status:</strong> {row.status}
                  </p>
                  <p>
                    <strong>Tipo:</strong> {row.tipo}
                  </p>

                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        );
      }


  return (
    <>
      <Header title="Histórico de Integrações / Logs Pathfind" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <div className="mb-3">
            {/*<Row className="mb-3">
              <FiltroAplicacoesPlano onApplyFilters={handleApplyFilters} />
            </Row>*/}
        {isLoading ? (
            <></>
          ) : (
          <Row>
            <Col md={1} className="mb-3">
              <Form.Group className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faFilter}
                  size="1x"
                  color="#000000"
                  className="mr-2"
                />

                <Form.Control
                  as="select"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  className="ml-2"
                >
                  {itemsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3 ml-auto">
              <Form.Group className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faSearch}
                  size="1x"
                  color="#000000"
                  className="mr-2"
                />

                <Form.Control
                  type="text"
                  placeholder="Digite para pesquisar"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="ml-2"
                />
              </Form.Group>
            </Col>
          </Row>
           )}
        </div>
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : loadError ? (
          <div className="center-btn">
            <h5 className="text-danger">{loadError}</h5>
          </div>
        ) : (
          <>
          <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell/>
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Data e Hora</StyledTableCell>
                    {/*<StyledTableCell>Envio</StyledTableCell>*/}
                    <StyledTableCell>Erro</StyledTableCell>
                    {/*<StyledTableCell>Id Requisição Sankhya</StyledTableCell>*/}
                    {/*<StyledTableCell>Retorno</StyledTableCell>*/}
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Tipo</StyledTableCell>
                    <StyledTableCell/>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems.map((item) => (
                    <ExpansibleRow key={item.id} row={item} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          <Row className="mt-3">
                <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                />
          </Row>
          </>
        )}
      </div>
    </>
  );
}
;

export default LogsPathfind;
